export default {
  label: 'Código de acesso',
  buttonLabel: 'Entrar',
  errorMessage: 'Código de acesso inválido',
};
